<template>
	<header class="masthead mb-auto">
		<nav class="navbar navbar-expand-lg fixed-top">
			<div class="container">
				<a class="navbar-brand" href="#">
					<img src="@/assets/img/logo.png" alt="Logo" />
				</a>
				<div class="my-2 my-lg-0">
					<button class="btn btn-light btn-sm my-2 my-sm-0" @click="gotoLogin">
						Login
					</button>
				</div>
			</div>
		</nav>
	</header>
</template>

<script>
export default {
	name: "Nav",
	data() {
		return {};
	},
	computed: {
		user() {
			return this.$store.state.user.userInfo.name;
		},
		showlogin() {
			return this.$store.state.user.logedin;
		},
		showHome() {
			if (this.$router.name) {
				return true;
			}
		},
	},
	methods: {
		logout() {
			this.$store.dispatch("logout").then((res) => {
				if (res == "true") {
					this.$router.push("/");
				}
			});
		},
		gotoLogin() {
			this.$router.push("/login");
		},
		gotoIntro() {
			this.$router.push("/");
		},
		gotoHome() {
			this.$router.push("/home");
		},
		gotoSearch() {
			this.$router.push("/search");
		},
		goToaccount() {
			this.$router.push("/account");
		},
	},
};
</script>

<style scoped></style>
